module.exports = __webpack_public_path__ + "img/gift.fa24241f.svg";